import React from 'react';

import './NoResultsFound.scss';

/**
 * NoResultsFound
 *
 * @description Component used to display no results found in the search list
 */
const NoResultsFound: React.FC = () => {
  return (
    <div className='no-results-found'>
      <p>No results found, try updating your search</p>
      <button type='reset'>
        Clear filters
      </button>
    </div>
  );
};

export default NoResultsFound;